import { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';

import { ellipsisStringNoCondition } from '../../../../utils/Helpers';

const HoverCellForNoteText = ({ value, noEllipsisMaxValue = 60 }) => {
  const op = useRef(null);

  const cellHoverRef = useRef(false);
  const panelHoverRef = useRef(false);

  const closeTimeoutRef = useRef(null);

  const scheduleClose = () => {
    clearTimeout(closeTimeoutRef.current);

    closeTimeoutRef.current = setTimeout(() => {
      if (!cellHoverRef.current && !panelHoverRef.current) {
        op.current?.hide();
      }
    }, 120);
  };

  return (
    <>
      <div
        style={{ display: 'flex', alignItems: 'center' }}
        onMouseEnter={e => {
          cellHoverRef.current = true;
          clearTimeout(closeTimeoutRef.current);
          op.current?.show(e);
        }}
        onMouseLeave={() => {
          cellHoverRef.current = false;
          scheduleClose();
        }}
      >
        <span>{ellipsisStringNoCondition(value, noEllipsisMaxValue)}</span>
      </div>

      <OverlayPanel
        ref={op}
        onMouseEnter={() => {
          panelHoverRef.current = true;
          clearTimeout(closeTimeoutRef.current);
        }}
        onMouseLeave={() => {
          panelHoverRef.current = false;
          scheduleClose();
        }}
      >
        <div
          style={{
            maxHeight: '200px',
            maxWidth: '300px',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            overflowY: 'auto',
          }}
        >
          {value}
        </div>
      </OverlayPanel>
    </>
  );
};

export default HoverCellForNoteText;
